import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/communication/index";

export const Route = createFileRoute("/admin/_modules/communication")({
  component: Page,
});
